module.exports = __webpack_public_path__ + "lt_LT-download-c0a307.webp";